(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/init.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.init = function() {
    svs.tipset.app.rootView = new svs.tipset.views.RootView();

    svs.tipset.models.gameDefinitions = new svs.tipset.models.GameDefinitions(
      svs.tipset.data.gameDefinitions
    );
    svs.tipset.collections.draws = new svs.tipset.collections.Draws();

    if (svs.tipset.collections.draws.getCurrentDraw()) {
      svs.tipset.objects.localstorageHandler = new svs.tipset.objects.LocalstorageHandler();
      svs.tipset.models.play = new svs.tipset.models.Play();
      if (svs.tipset.models.gameDefinitions.get('productName') == 'Powerplay') {
        svs.tipset.models.bombenXperten = new svs.tipset.models.BombenXperten();
        svs.tipset.collections.bombenDraws = new svs.tipset.collections.BombenDraws();
        svs.tipset.collections.bombenMatches = new svs.tipset.collections.BombenMatches();
      }
    }

    if (svs.utils.ns.isNamespace('svs.tipset.data.jackpot')) {
      svs.tipset.models.jackpot = new svs.tipset.models.Jackpot();
    }

    svs.tipset.models.header = new svs.tipset.models.Header();
    svs.tipset.models.reduceFreeContainer = new Backbone.Model({ rows: 0 });

    if (window.location.href.indexOf('tipssm') > -1) {
      if (
        svs.utils.ns.isNamespace('svs.competition.core.data.canPlayTipsSM') &&
        svs.competition.core.data.canPlayTipsSM &&
        svs.competition.Helper &&
        svs.competition.Helper.userIsParticipatingInTipsSM()
      ) {
        setTimeout(function() {
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'nav-games',
            title: 'Tips-SM-läget är på!',
            message: [
              {
                type: svs.components.dialog.message.TEXT,
                text: 'Nu kan du bara lägga spel på 64 rader.'
              }
            ],
            actions: [
              {
                title: 'OK'
              }
            ]
          }));
        }, 200);
      }
    }

    svs.obj.router = new svs.TipsetRouter();

    if (svs.tipset.collections.draws.getCurrentDraw()) {
      svs.tipset.views.contextualmenu = new svs.tipset.views.ContextMenu();
    }

    var productName = svs.tipset.models.gameDefinitions.get('productName');
    svs.core.data.title = { product: productName };

    if (
      svs.tipset.data.navigation &&
      svs.tipset.data.navigation.navigate == 'spelguide'
    ) {
      Backbone.history.navigate('/', { trigger: false });
      svs.tipset.views.contextualmenu.onSpelguide(
        svs.tipset.data.navigation.tab
      );
      delete svs.tipset.data.navigation;
    }

    if (
      svs.core.detect.feature('ft-share-game') &&
      svs.tipset.data.navigation &&
      svs.tipset.data.navigation.navigate === 'shareGame'
    ) {
      var drawId = svs.tipset.data.navigation.did,
        draw = svs.tipset.collections.draws.getDrawById(parseInt(drawId, 10));

      if (draw) {
        svs.components.Modal.show(
          svs.tipset.views.Share,
          {
            model: new svs.tipset.models.Share({})
          },
          {
            title: 'Dela rad',
            headerClass:
              svs.tipset.models.gameDefinitions.get('htmlClass') +
              '-modal-header',
            leftButton: {
              text: 'Stäng',
              visible: true,
              cssClass: 'btn-transparent-inverted',
              callback: function() {
                delete svs.tipset.data.navigation;
                Backbone.history.navigate('/', { trigger: false });
                svs.components.Modal.hide();
              }
            },
            rightButton: { visible: false }
          }
        );
      } else {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          type: svs.components.dialog.type.ERROR,
          title: 'Spelet är avslutat',
          actions: [
            {
              title: 'OK'
            }
          ]
        }));
      }
    }

    Backbone.history.start({
      pushState: Modernizr.history,
      root: svs.core.data.baseUrl
    });
  };

  svs.tipset.init();
})(Backbone, _, svs);

 })(window);